import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/el';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import DialogAction from '../Dialog/DialogAction';
import { Box } from '@mui/system';
import { Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
interface ICalendar {
  notes: {
    title: string;
    start: Date;
    end: Date
    startAdorment?: string //if not given, default (TextSnippetIcon) will be placed
  }[],
}

const mLocalizer = momentLocalizer(moment);

const MyCalendar = ({
  notes
}: ICalendar) => {
  
  const [open, setOpen] = React.useState<boolean>(false);
  const [selectedNotes, setSelectedNotes] = 
    React.useState<{ title: string; start: Date; end: Date; }[]>([]);
  
  moment.locale('el');

  const { views } = React.useMemo(
    () => ({
      views: {
        month: true,
        // agenda: true
      },
    }), []
  );

  const messages = {
    date: 'Ημερομηνία',
    time: 'Ώρα',
    event: 'Ραντεβού',
    allDay: 'Όλη μέρα',
    week: 'Εβδομάδα',
    work_week: 'Εργάσιμη Εβδομάδα',
    day: 'Ημέρα',
    month: 'Μήνας',
    // previous: 'Προηγούμενο',
    // next: 'Επόμενο',
    previous: '<',
    next: '>',
    yesterday: 'Χθες',
    tomorrow: 'Αύριο',
    today: 'Σήμερα',
    agenda: 'Ατζέντα',
    noEventsInRange: 'Δεν υπάρχουν ραντεβού σε αυτό το εύρος.',
    showMore: function (e: any) {
      return '+' + e + ' ακόμα';
    }
  };

  const createListItemBody = (note: any) => {
    return note.startAdorment
      ? <>
        <span style={{textDecoration: 'underline'}}>
          {note.startAdorment}:
        </span>
        &nbsp;{note.title}
      </> 
      : <>
        <ListItemIcon>
          <TextSnippetIcon/>
        </ListItemIcon>
        <ListItemText sx={{ml: 1}} primary={note.title} /> 
      </>;
  };

  return (
    <>
      <Calendar
        onShowMore={e => {
          setOpen(true);
          setSelectedNotes(e);
        }}
        messages={messages}
        localizer={mLocalizer}
        events={notes}
        startAccessor='start'
        endAccessor='end'
        views={views}
        style={{ height: '100%', width: '100%' }}
      />
      
      <DialogAction
        fullWidth 
        open={open}
        mode='info'
        content={
          <Box>
            <Typography variant='h3'>{`Σημειώσεις για ${moment(selectedNotes[0]?.start).format('DD/MM/YYYY')}`}</Typography>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <List
              sx={{ width: '100%' }}
            >
              {selectedNotes.map((note) => {
                return (
                  <ListItem key={JSON.stringify(note)}>
                    {createListItemBody(note)}
                  </ListItem>
                );
              })
              }
            </List>
          </Box>
        } 
        handleClose={() => setOpen(false)}
        onAccept={() => undefined}/>
    </>
  );
};

export default MyCalendar;